
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Search,
  Menu,
  X,
  User,
  ShoppingCart
} from "lucide-react";
import { useState } from "react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 w-full bg-background/80 backdrop-blur-md border-b border-border">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <div className="flex items-center">
          <Link to="/" className="flex items-center">
            <span className="text-xl font-semibold text-primary">FlowMarket</span>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6">
          <Link to="/marketplace" className="text-foreground hover:text-primary transition-colors">
            Marketplace
          </Link>
          <Link to="/pricing" className="text-foreground hover:text-primary transition-colors">
            Pricing
          </Link>
          <Link to="/sell" className="text-foreground hover:text-primary transition-colors">
            Sell Workflows
          </Link>
          <div className="px-2">
            <Button variant="ghost" size="icon">
              <Search className="h-5 w-5" />
            </Button>
          </div>
          <Link to="/auth" className="px-2">
            <Button variant="outline" size="sm">
              Log in
            </Button>
          </Link>
          <Link to="/auth?action=signup" className="px-2">
            <Button variant="default" size="sm">
              Sign up
            </Button>
          </Link>
          <Button variant="ghost" size="icon">
            <ShoppingCart className="h-5 w-5" />
          </Button>
        </div>

        {/* Mobile Navigation Trigger */}
        <div className="md:hidden flex items-center">
          <Button variant="ghost" size="icon" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu">
            {isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </Button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-background border-b border-border">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4">
            <Link to="/marketplace" className="text-foreground hover:text-primary transition-colors py-2" onClick={() => setIsMenuOpen(false)}>
              Marketplace
            </Link>
            <Link to="/pricing" className="text-foreground hover:text-primary transition-colors py-2" onClick={() => setIsMenuOpen(false)}>
              Pricing
            </Link>
            <Link to="/sell" className="text-foreground hover:text-primary transition-colors py-2" onClick={() => setIsMenuOpen(false)}>
              Sell Workflows
            </Link>
            <div className="flex space-x-4 pt-2">
              <Link to="/auth" className="flex-1">
                <Button variant="outline" className="w-full" onClick={() => setIsMenuOpen(false)}>
                  Log in
                </Button>
              </Link>
              <Link to="/auth?action=signup" className="flex-1">
                <Button variant="default" className="w-full" onClick={() => setIsMenuOpen(false)}>
                  Sign up
                </Button>
              </Link>
            </div>
            <div className="pt-2">
              <Link to="/cart" onClick={() => setIsMenuOpen(false)}>
                <Button variant="ghost" className="w-full flex items-center justify-center gap-2">
                  <ShoppingCart className="h-5 w-5" />
                  <span>Cart</span>
                </Button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
